import { Autocomplete, Box, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, Stack, Switch, TextField, Typography } from "@mui/material"
import { Localized } from "@fluent/react"
import { LoadingButton } from "@mui/lab"
import { useAppDispatch, useAppSelector } from "../../../app/hooks"
import { useCallback, useState } from "react"
import { showError, showSuccess } from "../../notifications/notificationsSlice"
import { ProjectProcess } from "../projectProcess/ProjectProcessApiClient"
import { createCustomProcess } from "./documentationProcessApiClient"
import SaveIcon from '@mui/icons-material/Save'
import { StructureTreeSelect } from "../../structure/StructureTreeSelect"
import { AppId } from "../../../app/appTypes"

const RequiredError = () => <Localized id="field-is-required"><span>Pole jest wymagane</span></Localized>

export interface CreateCustomDocumentationProcessProps {
    no: string
    name: string
    onSucces: (projectProcess: ProjectProcess) => void
    onCancel: () => void
}

export const CreateCustomDocumentationProcess = (props: CreateCustomDocumentationProcessProps) => {
    const dispatch = useAppDispatch()
    const [saving, setSaving] = useState(false)
    const [name, setName] = useState(props.name)
    const [no, setNo] = useState(props.no)
    const [validationErrors, setValidationErrors] = useState(false)
    const [structureId, setStructureId] = useState("")

    const noError = validationErrors && no === ""
    const nameError = validationErrors && name === ""


    const handleStructureSelected = useCallback((structureId: AppId) => {
        if (structureId) {
            setStructureId(structureId);
        }
    }, []);

    const handleSaveClick = async () => {
        setValidationErrors(true)
        if (no && name) {
            try {
                setSaving(true)

                const result =
                    await dispatch(createCustomProcess({
                        no: no,
                        name: name,
                        structureId: null
                    }))

                if (createCustomProcess.fulfilled.match(result)) {
                    const proc = result.payload as ProjectProcess;
                    dispatch(showSuccess("saved"))
                    props.onSucces(proc)
                }
                else {
                    let errorMsg = "error"
                    if (result.payload) {
                        if (result.payload.kind === 'http') {
                            const problem = result.payload.problem
                            if (problem) {
                                errorMsg = problem.title
                            }
                        }
                    }
                    dispatch(showError(errorMsg))
                }
            }
            catch (error) {
                dispatch(showError("error"))
            }
            finally {
                setSaving(false)
            }
        }
    }

    return <Dialog open={true} fullWidth maxWidth='md'>
        <DialogTitle><Localized id='process-new-creating'>_Nowy process</Localized></DialogTitle>
        <DialogContent>
            <Stack sx={{ mt: 2 }} spacing={2}>
                <TextField
                    fullWidth
                    autoFocus
                    error={noError}
                    helperText={noError && <RequiredError />}
                    inputProps={{ maxLength: 100 }}
                    value={no}
                    required
                    onChange={e => setNo(e.target.value)}
                    label={<Localized id='process-number'>_Process number</Localized>}
                />
                <TextField
                    fullWidth
                    autoFocus
                    error={nameError}
                    helperText={nameError && <RequiredError />}
                    inputProps={{ maxLength: 500 }}
                    value={name}
                    onChange={e => setName(e.target.value)}
                    label={<Localized id='process-name'>_Name</Localized>}
                />
                <Grid item xs={12}>
                    <StructureTreeSelect defaultStructureId={structureId} onStructureSelected={handleStructureSelected} />
                </Grid>
            </Stack>
        </DialogContent>
        <DialogActions>
            <LoadingButton loading={saving} size="small" color="success" variant="contained" startIcon={<SaveIcon />} onClick={handleSaveClick}>
                <Localized id="save">Zapisz</Localized>
            </LoadingButton>
            <LoadingButton loading={saving} size="small" onClick={props.onCancel} color="primary" variant="outlined">
                <Localized id="cancel">_cancel</Localized>
            </LoadingButton>
        </DialogActions>
    </Dialog>
}
